export default __webpack_public_path__ + "static/media/svg-1.cc907964.svg";